<template>
  <div id="blue-cross">
    <Header></Header>
    <img src="../assets/images/lanshiTop.png" alt="" />
    <service-case></service-case>
    <leave-message></leave-message>
    <img src="../assets/images/lanshiFooter.png" alt="" />
  </div>
</template>

<script>
import Header from "../components/Header";
import LeaveMessage from "../components/home/LeaveMessage";
import ServiceCase from "../components/blueCross/ServiceCase";
export default {
  name: "blueCross",
  components: {
    Header,
    LeaveMessage,
    ServiceCase
  }
};
</script>

<style lang="scss" scoped>
#blue-cross {
  width: 100%;
  height: 100%;
  background: #fafafa;
  /*text-align: center;*/
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
